const Resources = () => {
  return (
    <section className="resources">
      <div className="container">
        <h2>Resources</h2>
      </div>
    </section>
  )
}

export default Resources 